import React, { createContext, useContext } from "react";

export type FeatureState = {
  enabled: boolean;
  expires_at?: string | null;
  meta?: Record<string, any>;
};

export type FeatureMap = Record<string, FeatureState>;

const FeatureContext = createContext<FeatureMap | null>(null);

export function FeatureProvider({
  value,
  children,
}: {
  value: FeatureMap;
  children: React.ReactNode;
}) {
  return <FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>;
}

export function useFeatures() {
  const ctx = useContext(FeatureContext);
  if (!ctx) throw new Error("useFeatures must be used inside <FeatureProvider>");
  return ctx;
}

export function hasFeature(features: FeatureMap, key: string) {
  return Boolean(features?.[key]?.enabled);
}
